angular.module('Itao.IndicatorMap').directive('bookmarkNavigation', ['mapConfig', 'communeConfig', 'BookmarkService', function(mapConfig, communeConfig, BookmarkService) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'bookmarkNavigation.html',
    scope: {
      'currentConfig': '=',
      'bookmarks': '=',
      'onBookmarkSelect': '&',
      'categories': '='
    },
    link: function(scope){
      if(!angular.isArray(scope.bookmarks)) {
        scope.bookmarks = [];
      }

      scope.selection = {};
      scope.selectableCategories = [];
      scope.showEditButtons = communeConfig.showEditOptions;
      scope.selectableCategories = [];

      /**
       * Invokes the callbackFunction when a single bookmark gets selected
       * @param {object} bookmark Bookmark object which should be loaded
       */
      scope.loadBookmark = function(bookmark) {
        scope.onBookmarkSelect({
          bookmark: bookmark
        });
      };
    }
  };
}]);
